import styled from "styled-components"

export const StyledWrapper = styled.div`
  padding: 1rem 0rem 6rem 0rem;
  min-height: 100vh;
  position: relative;
  /* Needs z-index so contents inside will be aboe layered taboo cards */
  z-index:0;
  width: 30rem;
  max-width:100%;
  margin: 0 auto;  
`
